import React, { Component } from "react";
import PropTypes from "prop-types";
import InputField from "../../input-field/InputField";
import { validation } from "../primary-email-validation/PrimaryEmailValidation";

class Email extends Component {
  static propTypes = {
    customValidation: PropTypes.shape({
      validateOn: PropTypes.array.isRequired,
      validationRegex: PropTypes.instanceOf(RegExp).isRequired,
      required: PropTypes.bool.isRequired,
      message: PropTypes.shape({
        default: PropTypes.string.isRequired
      }).isRequired
    })
  };

  render() {
    const {
      id,
      name,
      placeholder,
      disabled,
      value,
      customValidation
    } = this.props;

    return (
      <InputField
        id={id || "email"}
        name={name || "email"}
        type="email"
        placeholder={placeholder || "Email Address"}
        disabled={disabled}
        validation={customValidation || validation}
        value={value}
      />
    );
  }
}

export default Email;
